exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inputContainer__workflowProductDetails-module___3K--e {\n  width: 100%;\n  margin-bottom: 12px;\n}\n", ""]);

// Exports
exports.locals = {
	"inputContainer": "inputContainer__workflowProductDetails-module___3K--e"
};